const actions = {
    MODULE_DETAILS_START: 'MODULE_DETAILS_START',
    MODULE_DETAILS_SUCCESS: 'MODULE_DETAILS_SUCCESS',
    MODULE_DETAILS_FAILURE: 'MODULE_DETAILS_FAILURE',

    COMPONENT_DETAILS_START: 'COMPONENT_DETAILS_START',
    COMPONENT_DETAILS_SUCCESS: 'COMPONENT_DETAILS_SUCCESS',
    COMPONENT_DETAILS_FAILURE: 'COMPONENT_DETAILS_FAILURE',

    ROLE_DETAILS_START: 'ROLE_DETAILS_START',
    ROLE_DETAILS_SUCCESS: 'ROLE_DETAILS_SUCCESS',
    ROLE_DETAILS_FAILURE: 'ROLE_DETAILS_FAILURE',

    FEATUREPERMISION_DETAILS_START: 'FEATUREPERMISION_DETAILS_START',
    FEATUREPERMISION_DETAILS_SUCCESS: 'FEATUREPERMISION_DETAILS_SUCCESS',
    FEATUREPERMISION_DETAILS_FAILURE: 'FEATUREPERMISION_DETAILS_FAILURE',

    FEATURE_DETAILS_START: 'FEATURE_DETAILS_START',
    FEATURE_DETAILS_SUCCESS: 'FEATURE_DETAILS_SUCCESS',
    FEATURE_DETAILS_FAILURE: 'FEATURE_DETAILS_FAILURE',

    FEATURE_COMPONENT_DETAILS_START: 'FEATURE_COMPONENT_DETAILS_START',
    FEATURE_COMPONENT_DETAILS_SUCCESS: 'FEATURE_COMPONENT_DETAILS_SUCCESS',
    FEATURE_COMPONENT_DETAILS_FAILURE: 'FEATURE_COMPONENT_DETAILS_FAILURE',

    CLEAR_SECURITY_DETAILS_START: 'CLEAR_SECURITY_DETAILS_START',
    CLEAR_SECURITY_DETAILS_SUCCESS: 'CLEAR_SECURITY_DETAILS_SUCCESS'
};

export default actions;